export default {
  coupon: {
    MemebrName: '会员姓名',
    StoreName: '使用门店',
    UseDate: '使用日期',
    Product: '购买产品',
    ArriveTime: '到账时间',
    FaceValue: '面值',
    LogisticsCode: '产品物流码'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mmc/eurlate/coupon.js